import { ActivityLogFeed } from "@/app/ActivityLogs/Components/ActivityLogFeed";
import { ModelType } from "@/gql/graphql";
import { useRelocationRecord } from "@/app/Relocations/Hooks/useRelocationRecord";

export function RelocationActivityScreen() {
  const record = useRelocationRecord();

  return (
    <div className="py-6">
      <ActivityLogFeed modelId={record.id} modelType={ModelType.Relocation} />
    </div>
  );
}
